import { Directive, Input, Output, EventEmitter, ElementRef } from '@angular/core';
declare var jQuery: any;
@Directive({
  selector: '[appDatepicker]',
})
export class DatepickerDirective {
  @Input('appDatepicker') dateValue: string | undefined;

  @Output() dateSelected: EventEmitter<string> = new EventEmitter();

  constructor(private el: ElementRef) {}

  ngAfterViewChecked(): void {
    let datepickerElement = jQuery(this.el.nativeElement);
    let scope = this;
    datepickerElement.datepicker({
      onSelect: function (dateText: string) {
        scope.dateValue = dateText;
        scope.dateSelected.emit(scope.dateValue);
      },
    });
  }
}
